import React, { useState } from 'react';
import { Box } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

function VideoPlayer({ lesson }) {
    const [showVideo, setShowVideo] = useState(false);

    if (!lesson) return null; // Prevent rendering if lesson is not available

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                aspectRatio: { xs: '16/9', md: '16/7.5' }, // Responsive aspect ratio for mobile and desktop
                backgroundColor: '#000',
                borderRadius: 0,
                mb: 2,
                cursor: 'pointer', // Interactive thumbnail
            }}
            onClick={() => setShowVideo(true)} // Show video on click
        >
            {!showVideo ? (
                <>
                    {/* Thumbnail Image */}
                    <Box
                        component="img"
                        src={lesson.thumbnail || '/static/img/default-thumbnail.png'} 
                        alt={`${lesson.title || "Lesson"} Thumbnail`}
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />
                    {/* Play Icon Overlay */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                            borderRadius: '50%',
                            padding: '12px',
                        }}
                    >
                        <PlayCircleOutlineIcon
                            sx={{
                                fontSize: '3rem',
                                color: '#fff',
                            }}
                        />
                    </Box>
                </>
            ) : (
                <iframe
                    src={`${lesson.content}?autoplay=1`} // Use `content` instead of `videoUrl`
                    title={lesson.title || "Lesson Video"}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </Box>
    );
}

export default VideoPlayer;
